import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import cls from './ColorPicker.module.css';
import { taskColors } from './model/taskColors';
import { Icon } from 'shared/ui';
import { useClickOutside } from 'shared/hooks';
import { Task } from '../../entities/task/model/types/tasks';
import { useAppDispatch, useAppSelector } from '../../store';
import { tasksSelector } from '../../entities/task/model/slice/taskSlice';
import { changeModalColor } from '../../widgets/Modals/model/slice/addModalSlice';
import { TModalMode } from '../../shared/model/types/modalMode.type';
import { changeEditModalColor } from '../../widgets/Modals/model/slice/editModalSlice';

interface Props {
    isDisabled: boolean;
    modalMode: TModalMode;
}

export const ColorPicker = ({ isDisabled = false, modalMode }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { rootRef } = useClickOutside({ isOpen, setIsOpen });
    const colorPickerRef = useRef<HTMLDivElement | null>(null);
    const [optionsStyle, setOptionsStyle] = useState<React.CSSProperties>({});
    const dispatch = useAppDispatch();
    const pickedTaskUid = new URLSearchParams(window.location.search).get('task_id');
    const taskData: Task = useAppSelector((state) =>
        tasksSelector.selectById(state, pickedTaskUid)
    );
    const [currentColor, setColor] = useState(taskData?.context?.color || '#9DA1AC');

    const handleColorPickerClick = () => {
        if (isDisabled) return;
        setIsOpen(!isOpen);
    };

    const handleColorSelect = (newColor: string) => {
        setColor(newColor);

        //диспатчим в стор в соответствии с модом модалки
        if (modalMode === 'addNewTask') {
            dispatch(changeModalColor(newColor));
        }
        if (modalMode === 'editTask') {
            dispatch(changeEditModalColor(newColor));
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const calcRect = () => {
            if (!isOpen) {
                setOptionsStyle({});
                return;
            }

            if (!colorPickerRef.current) return;

            const rect = colorPickerRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const openUpward = spaceBelow < 170;

            setOptionsStyle({
                position: 'fixed',
                top: openUpward ? rect.top - 8 : rect.bottom + 4,
                left: rect.left + rect.width / 2,
                transform: openUpward ? 'translate(-50%, -100%)' : 'translateX(-50%)',
            });
        };

        calcRect();

        window.addEventListener('resize', calcRect);
        window.addEventListener('scroll', calcRect, true);

        return () => {
            window.removeEventListener('resize', calcRect);
            window.removeEventListener('scroll', calcRect, true);
        };
    }, [isOpen]);

    return (
        <div
            ref={(node) => {
                rootRef.current = node;
                colorPickerRef.current = node;
            }}
            className={classNames(cls.ColorPicker, {
                [cls.Focused]: isOpen,
                [cls.disabled]: isDisabled,
            })}
            onClick={handleColorPickerClick}
        >
            <div
                className={cls.colorSquare}
                style={{ backgroundColor: currentColor || '#9DA1AC' }}
            />
            {!isDisabled && (
                <div
                    className={classNames(cls.arrow, {
                        [cls.openArrow]: isOpen,
                    })}
                >
                    <Icon iconName={'selectArrow'} fill={'#818998'} />
                </div>
            )}
            {isOpen && (
                <div className={cls.colorOptions} style={optionsStyle}>
                    {taskColors.map((color) => {
                        return (
                            <div
                                key={color}
                                className={classNames(cls.colorOption)}
                                style={{ backgroundColor: color }}
                                onClick={() => handleColorSelect(color)}
                            >
                                {currentColor === color && (
                                    <span className={cls.pickedColorOption} />
                                )}
                            </div>
                        );
                    })}
                    {/*<input*/}
                    {/*    type="color"*/}
                    {/*    value={currentColor}*/}
                    {/*    onChange={(e) => handleColorSelect(e.target.value)}*/}
                    {/*/>*/}
                </div>
            )}
        </div>
    );
};
